import { render, staticRenderFns } from "./Approval.vue?vue&type=template&id=317e462e&scoped=true&"
import script from "./Approval.vue?vue&type=script&lang=ts&"
export * from "./Approval.vue?vue&type=script&lang=ts&"
import style0 from "./Approval.vue?vue&type=style&index=0&id=317e462e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317e462e",
  null
  
)

export default component.exports